<template>
  <div class="information-details">
    <div class="details-title">{{ this.title }}</div>
    <div class="detail" v-for="detail in this.details" :key="detail">
      <img class="check" :src="require('@/assets/icons/check_mark.svg')"/>
      {{ detail }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'InformationDetails',
  props: {
    title: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

.information-details {
  margin-top: 30px;
  border-radius: 8px;
  background-color: #FEF7E3;
  padding: 24px;
  font-size: 16px;
  line-height: 1.38;

  .details-title {
    font-weight: bold;
    margin-bottom: 20px;
    margin-right: 26px;
  }
  .detail {
    display: flex;
    align-items: flex-start;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    .check {
      margin-left: 10px;
    }
  }
}

</style>
